import 'whatwg-fetch';
import { Controller } from 'stimulus';
import StripeInitializer from '../components/stripe_initializer/stripe_initializer';

export default class extends Controller {
    static targets = ['cardErrors', 'submitButton'];
    static elementStyles = {
        base: {
            color: '#32325D',
            fontWeight: 500,
            fontFamily: 'system-ui',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
                color: '#CFD7DF',
            },
        },
        invalid: {
            color: '#32325D',
            fontWeight: 500,
            fontFamily: 'system-ui',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
                color: '#FF0000',
            },
        },
    };

    connect() {
        this.secret = this.data.get('secret');
        this.intent = this.data.get('intent');
        this.formId = this.data.get('form');
        this.submitButtonTarget.disabled = true;

        StripeInitializer.load(window.stripe_api_key_url)
            .then((stripeObject) => {
                this.stripeObject = stripeObject;
                this.stripeElements = stripeObject.elements();
                this.intializeCardFields();
            })
            .catch((error) => {
                if (window.dtrum && typeof window.dtrum.reportError === 'function') {
                    window.dtrum.reportError(`Error loading stripe_card_fields_controller: ${error}`);
                }
            });

        if (this.formId) {
            document
                .getElementById(this.formId)
                .addEventListener('submit', (event) => {
                    event.preventDefault();
                    this.submitForm(event);
                });
        }
    }

    intializeCardFields() {
        this.stripeCard = this.stripeElements.create('card', {
            style: this.elementStyles,
        });

        this.stripeCard.mount('#card-number');
        this.stripeCard.on('change', this.handleStripeErrors.bind(this));
    }

    toggleCardInfo(e) {
        e.preventDefault();
        document.getElementById('drawer').classList.toggle('is-expanded');
    }

    submitForm(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.cardErrorsTarget.textContent !== '') {
            return false;
        }
        if (typeof this.intentResult === 'undefined') {
            if (this.intent === 'payment') {
                this.confirmCardPayment();
            }
            if (this.intent === 'setup') {
                this.confirmCardSetup();
            }
        } else {
            this.announcePaymentReady();
        }
    }

    confirmCardPayment() {
        this.submitButtonTarget.disabled = true;
        this.stripeObject
            .confirmCardPayment(
                this.secret,
                { payment_method: { card: this.stripeCard } }, // eslint-disable-line camelcase
                { handleActions: false }
            )
            .then((result) => {
                if (result.error) {
                    if (window.dtrum && typeof window.dtrum.reportError === 'function') {
                        window.dtrum.reportError(`Error confirming card payment in stripe_card_fields_controller; Stripe request: ${result.error['request_log_url']}`);
                    }
                    this.submitButtonTarget.disabled = true;
                } else {
                    this.intentResult = result.paymentIntent;
                    this.announcePaymentReady();
                    this.stripeCard.update({ disabled: true });
                }
            });
    }

    confirmCardSetup() {
        this.submitButtonTarget.disabled = true;
        this.stripeObject
            .confirmCardSetup(
                this.secret,
                { payment_method: { card: this.stripeCard } }, // eslint-disable-line camelcase
                { handleActions: false }
            )
            .then((result) => {
                if (result.error) {
                    this.cardErrorsTarget.innerHTML = result.error.message;
                    if (window.dtrum && typeof window.dtrum.reportError === 'function') {
                        window.dtrum.reportError(`Error confirming card setup in stripe_card_fields_controller; Stripe request: ${result.error['request_log_url']}`);
                    }
                    this.submitButtonTarget.disabled = true;
                } else {
                    this.intentResult = result.setupIntent;
                    this.announcePaymentReady();
                    this.stripeCard.update({ disabled: true });
                }
            });
    }

    announcePaymentReady() {
        let event = new CustomEvent('paymentReady', {
            detail: {
                payment_method_id: this.intentResult.payment_method, // eslint-disable-line camelcase
                button: this.submitButtonTarget,
            },
        });
        window.dispatchEvent(event);
    }

    handleStripeErrors(event) {
        if (event.brand === 'amex') {
            this.cardErrorsTarget.textContent =
                'Sorry, we do not accept American Express cards.';
            this.submitButtonTarget.disabled = true;
            return;
        }

        if (event.complete) {
            this.cardErrorsTarget.textContent = '';
            this.submitButtonTarget.disabled = false;
        } else if (event.error) {
            this.cardErrorsTarget.textContent = event.error.message;
            this.submitButtonTarget.disabled = true;
        }
    }
}
